/**
 * Disables the legal-documents submit button until every consent checkbox is
 * checked, matching the Figma design (a tooltip explains why while disabled)
 * instead of only surfacing an error after the user tries to continue.
 */
export const initLegalDocsGate = () => {
  const button = document.getElementById('legal-docs-submit-button');
  const checkboxes = document.querySelectorAll('.js-legal-doc-checkbox');
  if (!button || checkboxes.length === 0) return;

  const syncDisabledState = () => {
    button.disabled = [...checkboxes].some((checkbox) => !checkbox.checked);
  };

  for (const checkbox of checkboxes) {
    checkbox.addEventListener('change', syncDisabledState);
  }
  syncDisabledState();
};
